import 'react-toastify/dist/ReactToastify.css';

import React, { Suspense, lazy } from 'react';
import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';

import { CartProvider } from './CartContext';
import { ToastContainer } from 'react-toastify';
import { useMediaQuery } from 'react-responsive';

// Lazy load components
const AddressDetails = lazy(() => import('./components/address-details'));
const Contactus = lazy(() => import('./components/contactus'));
const ContactusMobile = lazy(() => import('./components/contactusMbile'));
const Home = lazy(() => import('./components/home'));
const HomeMobile = lazy(() => import('./components/homeMobile'));
const Menu = lazy(() => import('./components/menu'));
const MenuMobile = lazy(() => import('./components/menuMobile'));
const OrderOnline = lazy(() => import('./components/OrderOnline'));
const OrderOnlineMobile = lazy(() => import('./components/OrderOnlinemble'));
const OurStory = lazy(() => import('./components/ourstory'));
const OurStoryMobile = lazy(() => import('./components/ourstoryMobile'));
const Payment = lazy(() => import('./components/payment'));
const PrivacyPolicy = lazy(() => import('./components/privacy-policy'));
const TermsAndConditions = lazy(() => import('./components/terms-and-conditions'));
const TortillaCustomize = lazy(() => import('./components/tortilla-customize'));
const ViewCartMobile = lazy(() => import('./components/view-cart-mobile'));

const CustomizationWrapper = ({ bowl }) => {
  const location = useLocation();
  const cardData = location.state?.card || null;

  return <TortillaCustomize bowl={bowl} card={cardData} />;
};

function App() {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  return (
    <Router>
      <div className='App'>
        <ToastContainer position='top-right' autoClose={2000} newestOnTop />

        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route
              path='/'
              element={
                <CartProvider>{isMobile ? <HomeMobile /> : <Home />}</CartProvider>
              }
            />
            <Route path='/privacy-policy' element={<CartProvider><PrivacyPolicy /></CartProvider>} />
            <Route path='/terms-and-conditions' element={<CartProvider><TermsAndConditions /></CartProvider>} />
            <Route
              path='/ourstory'
              element={<CartProvider>{isMobile ? <OurStoryMobile /> : <OurStory />}</CartProvider>}
            />
            <Route
              path='/menu'
              element={<CartProvider>{isMobile ? <MenuMobile /> : <Menu />}</CartProvider>}
            />
            <Route
              path='/order-online'
              element={<CartProvider>{isMobile ? <OrderOnlineMobile /> : <OrderOnline />}</CartProvider>}
            />
            <Route
              path='/view-cart'
              element={isMobile && <CartProvider><ViewCartMobile /></CartProvider>}
            />
            <Route path='/address-details' element={<CartProvider><AddressDetails /></CartProvider>} />
            <Route path='/payment-details' element={<CartProvider><Payment /></CartProvider>} />
            <Route path='/tortilla-customize' element={<CartProvider><CustomizationWrapper bowl={false} /></CartProvider>} />
            <Route path='/bowl-customize' element={<CartProvider><CustomizationWrapper bowl={true} /></CartProvider>} />
            <Route
              path='/contactus'
              element={<CartProvider>{isMobile ? <ContactusMobile /> : <Contactus />}</CartProvider>}
            />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
